import OkC from "shared/util/OkcApi";

export const loadInstagram = (userid) => {
	return OkC.api(`/profile/${userid}/photos/instagram`);
};



// WEBPACK FOOTER //
// ./src/apps/profile_instagram/util/web.js